module.exports = __webpack_public_path__ + "static/media/home_of_poi_logo.c530ab13.jpg";